import React, { memo, forwardRef } from "react";
const SvgAlphabetR = forwardRef((props, svgRef) => {
  return (
    <svg
      width={32}
      height={32}
      fill="none"
      viewBox="0 0 32 32"
      ref={svgRef}
      {...props}
    >
      <path
        fill="#717171"
        d="M15.36 19.69c0 .28-.047.513-.14.7a.97.97 0 01-.32.4.909.909 0 01-.4.18 1.22 1.22 0 01-.34.06c-.107 0-.227-.02-.36-.06a1.064 1.064 0 01-.4-.18 1.243 1.243 0 01-.32-.4c-.08-.187-.12-.42-.12-.7v-7.34c0-.267.04-.48.12-.64.093-.173.2-.307.32-.4a.915.915 0 01.36-.18c.133-.04.247-.06.34-.06.093 0 .207.02.34.06.133.027.26.087.38.18s.22.227.3.4c.093.16.14.373.14.64v.5h.04c.187-.52.5-.96.94-1.32.453-.373.973-.56 1.56-.56.36 0 .653.093.88.28.24.173.36.433.36.78 0 .307-.1.58-.3.82-.2.227-.533.34-1 .34-.76 0-1.347.26-1.76.78-.413.507-.62 1.16-.62 1.96v3.76z"
      />
    </svg>
  );
});
SvgAlphabetR.displayName = "SvgAlphabetR";
const MemoForwardRef = memo(SvgAlphabetR);
export default MemoForwardRef;
